import React from 'react';
import './CookiePolicy.css';
import Footer from '../components/home/Footer';

function CookiePolicy() {
  return (
    <div className="cookie-policy">
      <div className="policy-container">
        <h1>Cookie Policy</h1>
        <p className="last-updated">Last updated: April 2026</p>

        <section>
          <h2>1. What Are Cookies</h2>
          <p>
            Cookies are small files of letters and numbers that we store on your browser or the hard drive of your computer if you agree. Cookies contain information that is transferred to your computer's hard drive.
          </p>
        </section>

        <section>
          <h2>2. How We Use Cookies</h2>
          <p>
            We use cookies for a variety of reasons detailed below. Unfortunately, in most cases there are no industry standard options for disabling cookies without completely disabling the functionality and features they add to this site. It is recommended that you leave on all cookies if you are not sure whether you need them or not in case they are used to provide a service that you use.
          </p>
        </section>

        <section>
          <h2>3. Types of Cookies We Use</h2>
          <ul>
            <li>
              <strong>Essential Cookies:</strong> These cookies are necessary for the website to function properly. They enable core functionality such as security, network management, and accessibility.
            </li>
            <li>
              <strong>Performance Cookies:</strong> These cookies collect information about how visitors use our website, such as which pages are visited most often, and if they get error messages from web pages.
            </li>
            <li>
              <strong>Functional Cookies:</strong> These cookies allow us to remember choices you make (such as your user name, language, or the region you are in) and provide enhanced, more personal features.
            </li>
            <li>
              <strong>Targeting Cookies:</strong> These cookies record your visit to our website, the pages you have visited, and the links you have followed. We will use this information to make our website and the advertising displayed on it more relevant to your interests.
            </li>
          </ul>
        </section>

        <section>
          <h2>4. Disabling Cookies</h2>
          <p>
            You can prevent the setting of cookies by adjusting the settings on your browser (see your browser Help for how to do this). Be aware that disabling cookies will affect the functionality of this and many other websites that you visit. Disabling cookies will usually result in also disabling certain functionality and features of the this site. Therefore it is recommended that you do not disable cookies.
          </p>
        </section>

        <section>
          <h2>5. More Information</h2>
          <p>
            Hopefully that has clarified things for you. As it was previously mentioned, if you are unsure whether you want to allow the cookies or not, it is usually safer to leave cookies enabled in case it interacts with one of the features you use on our site.
          </p>
        </section>

        <section>
          <h2>6. Contact Us</h2>
          <p>
            If you have any questions about our Cookie Policy, please contact us at:
          </p>
          <p>
            Email: hr@cofounderhubs.com
          </p>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default CookiePolicy;
